import React from "react";

function Dots() {
  const numberOfDots = 1500; // O el número que estés usando
  const dots = [];
  const baseDotColorHex = "#8A2BE2"; // Color principal del punto
  const columns = Math.floor(
    window.innerWidth / (window.innerHeight * 0.03 + window.innerHeight * 0.01)
  ); // 3vh + 1vh gap
  const rows = Math.ceil(numberOfDots / columns);
  // Definimos perfiles de brillo para los puntos
  const brightnessProfiles = [
    {
      // Casi imperceptible
      id: "faint",
      config: () => ({
        opacity: Math.random() * (0.2 - 0.1) + 0.1, // Opacidad muy baja: 0.1 a 0.3
        boxShadow: `0 0 ${Math.floor(
          Math.random() * (4 - 2) + 2
        )}px rgba(138, 43, 226, ${Math.random() * (0.3 - 0.1) + 0.1})`, // Sombra sutil
      }),
    },
    {
      // Casi imperceptible
      id: "faint2",
      config: () => ({
        opacity: Math.random() * (0.3 - 0.1) + 0.1, // Opacidad muy baja: 0.1 a 0.3
        boxShadow: `0 0 ${Math.floor(
          Math.random() * (4 - 2) + 2
        )}px rgba(138, 43, 226, ${Math.random() * (0.3 - 0.1) + 0.1})`, // Sombra sutil
      }),
    },
    {
      // Tenue
      id: "dim2",
      config: () => ({
        opacity: Math.random() * (0.2 - 0.15) + 0.15, // Opacidad baja: 0.15 a 0.4
        boxShadow: `0 0 ${Math.floor(
          Math.random() * (6 - 2) + 2
        )}px rgba(138, 43, 226, ${Math.random() * (0.4 - 0.1) + 0.1})`,
      }),
    },
    {
      // Medio
      id: "medium2",
      config: () => ({
        opacity: Math.random() * (0.7 - 0.35) + 0.35, // Opacidad media: 0.35 a 0.7
        boxShadow: `0 0 ${Math.floor(
          Math.random() * (12 - 5) + 5
        )}px rgba(148, 0, 211, ${
          Math.random() * (0.6 - 0.25) + 0.25
        }), 0 0 ${Math.floor(
          Math.random() * (6 - 2) + 2
        )}px rgba(148, 0, 211, ${Math.random() * (0.5 - 0.2) + 0.2})`,
      }),
    },
    {
      // Brillante
      id: "bright2",
      config: () => {
        const brightColor = ["#9370DB", "#DA70D6", "#E6E6FA"][
          Math.floor(Math.random() * 3)
        ];
        return {
          opacity: Math.random() * (1.0 - 0.6) + 0.6, // Opacidad alta: 0.6 a 1.0
          boxShadow: `0 0 ${Math.floor(
            Math.random() * (18 - 8) + 8
          )}px ${brightColor}, 0 0 ${Math.floor(
            Math.random() * (10 - 4) + 4
          )}px ${brightColor}, 0 0 3px rgba(255,255,255,0.6)`,
        };
      },
    },
  ];

  for (let i = 0; i < numberOfDots; i++) {
    const row = Math.floor(i / columns);
    const normalizedRow = row / (rows - 1); // 0 arriba, 1 abajo

    // Invertimos la probabilidad: más arriba, menos puntos
    const FADE_EXPONENT = 5;
    const activityProbability = Math.pow(normalizedRow, FADE_EXPONENT);

    let styleConfig;
    let currentBackgroundColor = baseDotColorHex;

    if (Math.random() < activityProbability) {
      const randomProfile =
        brightnessProfiles[
          Math.floor(Math.random() * brightnessProfiles.length)
        ];
      styleConfig = randomProfile.config();
    } else {
      styleConfig = {
        opacity: Math.random() * (0.08 - 0.01) + 0.01,
        boxShadow: "none",
      };
      currentBackgroundColor = "transparent";
    }

    const style = {
      backgroundColor: currentBackgroundColor,
      opacity: styleConfig.opacity,
      boxShadow: styleConfig.boxShadow,
    };

    dots.push(<div className="dot" key={i} style={style}></div>);
  }

  return <div className="dots-background">{dots}</div>;
}

export default Dots;
